// Local-calendar date helpers. Using `new Date().toISOString().slice(0,10)`
// gives the UTC date, which is a day off for AEST/AEDT users late in the day —
// so "Today" and the tips-email date must be computed from local parts.

const toLocalIso = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** Today's date as a local yyyy-MM-dd string. */
export function todayLocalIso(): string {
  return toLocalIso(new Date());
}

/** Shift a yyyy-MM-dd string by `days` on the local calendar (no UTC drift). */
export function shiftDateIso(dateStr: string, days: number): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  date.setDate(date.getDate() + days);
  return toLocalIso(date);
}
